import { Box, Grid, Typography } from '@mui/material';
import TeamsControls from 'components/@home/drawers/ChannelDrawer/Form/controls/TeamsControls';
import TooltipIfFromTeam from 'components/@home/drawers/ChannelDrawer/Form/TooltipIfFromTeam';
import Checkbox from 'components/formik/Checkbox';
import PhotoUpload from 'components/formik/PhotoUpload';
import Switch from 'components/formik/Switch';
import TextField from 'components/formik/TextField';
import { FastField, Form } from 'formik';
import { arrayOf, bool, object } from 'prop-types';
import React from 'react';
import employeeShape from 'shapes/employee';
import { I18n } from 'utils/i18n';
import withNavigate from 'utils/withNavigate';
import connector from './connector';
import formik from './formik';
import ActionButtons from './formik/ActionButtons';
import EmployeesTable from './formik/EmployeesTable';
import Headline from './Headline';
import Label from './Label';

const ChannelForm = ({ errors, isSuperAdmin, values, isEdit, employees, actions }) => {
  const handleReset = () => {
    actions.drawers.channel.close();
  };

  return (
    <Form
      style={{
        flexGrow: 1,
        padding: '20px',
        maxWidth: 'calc(100% - 60px)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Headline isEdit={isEdit} />
      <Box
        sx={theme => ({
          display: 'flex',
          flex: '1 0 auto',
          [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
          },
          paddingBottom: '30px',
          borderBottom: `1px solid ${theme.palette.divider}`,
        })}
      >
        <Box sx={{ pt: '20px', pr: '20px' }}>
          <FastField component={PhotoUpload} name="avatar" />
        </Box>

        <div>
          <Label>{I18n.t('ChannelDrawer.NameField.label')}</Label>
          <FastField
            component={TextField}
            autoComplete="off"
            placeholder={I18n.t('ChannelDrawer.NameField.placeholder')}
            name="name"
          />
          <Label>{I18n.t('ChannelDrawer.DescriptionField.label')}</Label>
          <FastField
            component={TextField}
            autoComplete="off"
            placeholder={I18n.t('ChannelDrawer.DescriptionField.placeholder')}
            name="description"
          />
          <div>
            <Label>{I18n.t('ChannelDrawer.Permissions.label')}</Label>
            <Grid rowSpacing={2} columnSpacing={0} container sx={{ alignItems: 'flex-start' }}>
              <Grid size={1}>
                <FastField
                  component={Switch}
                  name="isReadOnly"
                  id="isReadOnly"
                  multiple={false}
                  sx={{ margin: 0 }}
                />
              </Grid>
              <Grid component="label" htmlFor="isReadOnly" sx={{ pt: 0 }} size={11}>
                <Typography>{I18n.t('ChannelDrawer.Permissions.Read only')}</Typography>
                <Typography variant="caption">
                  {I18n.t('ChannelDrawer.Permissions.Read only description')}
                </Typography>
              </Grid>
              <Grid size={1}>
                <FastField
                  component={Switch}
                  name="isMuteable"
                  id="isMuteable"
                  multiple={false}
                  sx={{ margin: 0 }}
                />
              </Grid>
              <Grid component="label" htmlFor="isMuteable" sx={{ pt: 0 }} size={11}>
                <Typography>{I18n.t('ChannelDrawer.Permissions.Silence notifications')}</Typography>
                <Typography variant="caption">
                  {I18n.t('ChannelDrawer.Permissions.Silence notifications description')}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>
      </Box>

      <TeamsControls actions={actions} />

      <FastField component={EmployeesTable} employees={employees} name="members" isEdit={isEdit} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {!isSuperAdmin && !values.isReadOnly?.[0] && (
          <Box sx={{ display: 'flex', alignItems: 'center', justifySelf: 'flex-start' }}>
            <TooltipIfFromTeam member={values.me} teams={[]}>
              <FastField
                disabled={values.optOutDisabled}
                component={Checkbox}
                label={I18n.t('ChannelDrawer.Opt out from this group')}
                name="isOptedOut"
              />
            </TooltipIfFromTeam>
          </Box>
        )}
        <div>
          {errors.server && (
            <Typography align="right" color="error" sx={{ padding: '0 20px', alignSelf: 'center' }}>
              {errors.server}
            </Typography>
          )}
        </div>
        <ActionButtons onReset={handleReset} isEdit={isEdit} />
      </Box>
    </Form>
  );
};

ChannelForm.propTypes = {
  actions: object.isRequired,
  isEdit: bool.isRequired,
  isSuperAdmin: bool.isRequired,
  values: object.isRequired,
  employees: arrayOf(employeeShape).isRequired,
  errors: object.isRequired,
};

export default withNavigate(connector(formik(ChannelForm)));
